import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from './shared/components-generals/header/header.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal('RedJaliscoUI');
  protected isLoggedIn = false;

  constructor(
    private translate: TranslateService,
    private router: Router,
  ) {
    this.translate.setDefaultLang('es');
    this.translate.use('es');

    this.router.events.subscribe(() => {
      this.isLoggedIn = this.router.url !== '/login';
    });
  }
}
